// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$eventApiService = {
      event_api_url: `${process.env.VUE_APP_ACTIVITY_API_URL}/events`,

      /**
       * 查詢
       * @param {*} param 
       * @returns 
       */
      async query(param = '') {
        const url = `${this.event_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 查詢活動年份清單
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getListOfEventYear(additional = '') {
        const url = `${this.event_api_url}/event-year`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過 ID 查詢
       * @param {*} id 
       * @param {*} additional 
       * @returns 
       */
      async getById(id, additional = '') {
        const url = `${this.event_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 查詢時程
       * @param {*} event 
       * @param {*} additional 
       * @returns 
       */
      async fetchSchedules(event, additional = '') {
        const url = `${this.event_api_url}/${event.id}/schedules`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 查詢講義
       * @param {*} event 
       * @param {*} additional 
       * @returns 
       */
      async fetchHandouts(event, additional = '') {
        const url = `${this.event_api_url}/${event.id}/handouts`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 查詢目前時程
       * @param {*} event 
       * @param {*} additional 
       * @returns 
       */
      async getCurrentSchedule(event, additional = '') {
        const url = `${this.event_api_url}/${event.id}/current-schedule`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      }
    }
  }
}
